import Vue from 'vue'
import gyl from './gyl.vue'
import '@/util/appUtil.js'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(gyl)
})



// WEBPACK FOOTER //
// ./src/pages/gyl/gyl.js